export default "__VITE_ASSET__7u3uazjb__"